
// Get siblings
const getSiblings = n => [...n.parentNode.children].filter(c => c.nodeType == 1 && c != n);
// ============================

// let's get this party started

window.addEventListener('load', function () {
  document.body.classList.add('loaded');
})

setTimeout(() => {
  document.body.classList.add('loaded');
}, 7000);

document.addEventListener('DOMContentLoaded', function () {


  // INITIAL SCROLL
  const scrollerHash = new SweetScroll({
    duration: 0,
  });
  const realHash = window.location.hash;
  const hash = `#s-${realHash.substring(1)}`;
  const needsInitialScroll = document.querySelector(hash) != null;
  window.addEventListener('load', function () {
    if (needsInitialScroll) {
      // setTimeout(() => {
      scrollerHash.to(hash);
      // }, 100);      
    }
  }, false);


  // if (window.location.hash) {
  //   const hash = window.location.hash.substring(1);
  //   const hashTarget = `#s - ${ hash }`;
  //   if (document.querySelector(hashTarget)) {
  //     setTimeout(() => {
  //       scroller.to(hashTarget);
  //     }, 150);
  //   }
  // }

  setTimeout(() => {
    document.body.classList.add('loaded');
  }, 3500);


  const swiper = new Swiper('.js_swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 5
    },
    // on: {
    //   init: function () {
    //     console.log('swiper initialized');
    //   },
    // },
  });

  document.querySelectorAll('.js_mg2').forEach(trigger => {
    trigger.addEventListener('click', (e) => {

      const targetSLide = parseInt(trigger.getAttribute('data-slide'));

      swiper.slideTo(targetSLide - 1);

      const targetBlock = targetSLide < 13
        ? 'color'
        : targetSLide >= 13 && targetSLide < 19
          ? 'head'
          : targetSLide >= 19 && targetSLide < 25
            ? 'clothes'
            : targetSLide >= 25 && targetSLide < 31
              ? 'body'
              : targetSLide >= 31 && targetSLide < 37
                ? 'filling'
                : 'background'

      document.querySelector('.s-mg2').setAttribute('data-slide', targetSLide);

      document.querySelector('.mg2').setAttribute('data-slide', targetSLide);
      document.querySelector('.mg2').setAttribute('data-block', targetBlock);

    });
  });





  let controller = new ScrollMagic.Controller();

  function makeScrollMagic() {
    new ScrollMagic.Scene({
      triggerElement: 'body',
      triggerHook: 0,
      duration: window.innerHeight * 0.7,
    })
      .setClassToggle('.s-main__pic', 'm-show')
      .setTween('.s-main__img', {
        opacity: 0
      }) // the tween durtion can be omitted and defaults to 1
      // .addIndicators({ name: "2 (duration: 300)" }) // add indicators (requires plugin)
      .addTo(controller);

    // ~~~~~~~~ MG1 ~~~~~~~~~~~

    const mg1Dura = window.innerHeight * 1.3;
    const mg1DuraM = window.innerHeight * 4;


    if (window.matchMedia("(max-width: 767.92px)").matches) {

      new ScrollMagic.Scene({
        triggerElement: '.mg1-trigger',
        triggerHook: 0,
        duration: mg1DuraM,
      })
        .setClassToggle('body', 'm-holdmenu')
        .setPin('.mg1-spacer')
        .addTo(controller);

      const sceneFadeItemsM = document.querySelectorAll('.mg1__item:not(.mg1__item_0)');

      const fraction = mg1DuraM / sceneFadeItemsM.length;

      for (let i = 0; i < sceneFadeItemsM.length; i++) {

        new ScrollMagic.Scene({
          triggerElement: '.mg1-trigger',
          triggerHook: 0,
          offset: fraction * i + fraction * 0.3,
          duration: fraction - fraction * 0.2
        })
          .setTween(sceneFadeItemsM[i], {
            opacity: 1
          })
          .addTo(controller);
      }
    }

    if (window.matchMedia("(min-width: 768px)").matches) {
      new ScrollMagic.Scene({
        triggerElement: '.mg1-trigger',
        triggerHook: 0,
        duration: mg1Dura,
      })
        .setClassToggle('body', 'm-holdmenu')
        .setPin('.mg1-spacer')
        // .addIndicators({ name: "2 (duration: 300)" }) // add indicators (requires plugin)
        .addTo(controller);


      let vw = 'vw',
        perc = 13.5,
        correction = 0,
        corrmid = 9,
        corrlast = 6;

      if (window.matchMedia("(min-width: 1500px)").matches) {
        correction = -20;
        vw = '%';
        perc = 30.5;
        corrmid = 0;
        corrlast = -7;


        new ScrollMagic.Scene({
          triggerElement: '.mg1-trigger',
          triggerHook: 0,
          duration: mg1Dura * 0.75
        })
          .setTween('.mg1', {
            transform: `translateX(calc((100vw - 1500px - 132px * 2) / 2)`
          })
          // .setTween(TweenMax.to(sceneItems[i], 1, { opacity: 1 })) // Comment if no GSAP
          // .addIndicators() // add indicators (requires plugin)
          .addTo(controller);
      }

      const sceneMoveItems = document.querySelectorAll('.mg1__item:not(.mg1__item_0)');
      for (let i = 0; i < sceneMoveItems.length; i++) {
        if (i > 0 && i < 5) correction = corrmid;
        else if (i === 5) correction = corrlast;


        new ScrollMagic.Scene({
          triggerElement: '.mg1-trigger',
          triggerHook: 0,
          duration: mg1Dura * 0.75
        })
          .setTween(sceneMoveItems[i], {
            transform: `translateX(${(perc * i) - correction}${vw})`
          })
          // .setTween(TweenMax.to(sceneMoveItems[i], 1, { opacity: 1 })) // Comment if no GSAP
          // .addIndicators() // add indicators (requires plugin)
          .addTo(controller);
      }
      const sceneFadeItems = document.querySelectorAll('.mg1__fade');
      for (let i = 0; i < sceneFadeItems.length; i++) {

        new ScrollMagic.Scene({
          triggerElement: '.mg1-trigger',
          triggerHook: 0,
          offset: mg1Dura * 0.6,
          duration: mg1Dura * 0.2
        })
          .setTween(sceneFadeItems[i], {
            opacity: 1
          })
          .addTo(controller);
      }
    }
    // ~~~~~~~~ MG1 ~~~~~~~~~~~

  }

  makeScrollMagic();



  let winWidth = window.innerWidth;
  let throttleresize;
  window.addEventListener('resize', function () {
    let newWinWidth = window.innerWidth;
    if (newWinWidth !== winWidth) {
      newWinWidth = newWinWidth;
      clearTimeout(throttleresize)
      throttleresize = setTimeout(function () {
        controller = controller.destroy(true);
        controller = new ScrollMagic.Controller();
        makeScrollMagic();
      }, 150)
    }
  }, false)


  // SCROLL TO
  const scroller = new SweetScroll(
    {
      /* some options */
      trigger: '[data-scroll]',       // Selector for trigger (must be a valid css selector)
      header: '[data-scroll-header]', // Selector or Element for fixed header (Selector of must be a valid css selector)
      // header: '#header',
      duration: 1000,                 // Specifies animation duration in integer
      easing: 'easeInOutSine',         // Specifies the pattern of easing
      offset: 0,                      // Specifies the value to offset the scroll position in pixels
      vertical: true,                 // Enable the vertical scroll
      horizontal: false,              // Enable the horizontal scroll
      cancellable: true,              // When fired wheel or touchstart events to stop scrolling
      updateURL: false,               // Update the URL hash on after scroll (true | false | 'push' | 'replace')
      preventDefault: true,           // Cancels the container element click event
      stopPropagation: true,          // Prevents further propagation of the container element click event in the bubbling phase

      // Callbacks
      // before: null,
      after: (offset, $trigger, scroller) => {
        // move focus to target
        let targetItem;
        if (!$trigger && offset.top === 0) {
          targetItem = document.body;
        } else if ($trigger && $trigger.getAttribute('href')) {
          targetItem = document.querySelector($trigger.getAttribute('href'));
        } else if ($trigger && $trigger.getAttribute('data-scroll').substring(0, 1) === '#') {
          targetItem = document.querySelector($trigger.getAttribute('data-scroll'));
        }
        if (targetItem) {
          targetItem.focus();
          if (targetItem !== document.activeElement) {
            targetItem.setAttribute('tabindex', '-1');
            targetItem.focus();
            targetItem.blur();
            targetItem.removeAttribute('tabindex');
          }
        }
      },
      // cancel: null,
      // complete: null,
      // step: null,


      // // Stop scrolling case of trigger element that contains the `is - disabled` class.
      // before: (offset: Offset, $trigger: Element | null, scroller: SweetScroll): boolean | void => {
      //   console.log('Before!!', offset, scroller);
      //   if ($trigger && $trigger.classList.contains('is-disabled')) {
      //     return false;
      //   }
      // },

      // // If the `wheel` or `touchstart` event is called
      // cancel: (scroller: SweetScroll): void => {
      //   console.log('Cancel!!', scroller);
      // },

      // // Scroll animation is complete
      // after: (offset: Offset, $trigger: Element | null, scroller: SweetScroll): void => {
      //   console.log('After!!', offset, $trigger, scroller);
      // },

      // // Scroll animation is complete (`after` or `cancel`)
      // complete: (isCancel: boolean, scroller: SweetScroll): void => {
      //   console.log('Complete!!', isCancel, scroller);
      // },

      // // Each animation frame
      // step: (time: number, scroller: SweetScroll): void => {
      //   console.log('step', time, scroller);
      // },
    },
    // '#container',
    // document.getElementById('container'),
  );

  // scroller.to('#footer');
  // scroller.to({ top: 1000, left: 20 });
  // // Array (top:0, left:1000)
  // scroller.to([0, 1000]);
  // scroller.to(500);
  // scroller.to('+=500');
  // scroller.toTop(0);
  // scroller.toLeft(1500);
  // scroller.toElement(document.getElementById('content'));

  // scroller.update({
  //   trigger: 'a[href^="#"]',
  //   duration: 3000,
  // });

  // scroller.stop(true);
  // scroller.destroy();

  // SOME HTML OPTIONS
  // data-scroll="#target"
  // data-scroll="+=500"
  // data-scroll-options='{"easing": "easeOutExpo"}'



  document.querySelectorAll('[data-scroll-top]').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      scroller.toTop(0);
    });
  });



  //===============================




  // SLIDEDOWN
  let slideHold = false;
  const slideUp = (target, duration = 500) => {
    slideHold = true;
    target.classList.remove('m-active');
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      slideHold = false;
    }, duration);
  }
  const slideDown = (target, duration = 500) => {
    target.classList.add('m-active');
    slideHold = true;
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      slideHold = false;
    }, duration);
  }
  const slideToggle = (target, duration = 500) => {
    return window.getComputedStyle(target).display === 'none'
      ? slideDown(target, duration)
      : slideUp(target, duration);
  }

  let scrollHold = false;
  document.querySelectorAll('.js_slidedown_trigger').forEach(trigger => {

    trigger.addEventListener('click', (e) => {
      scrollHold = true;
      e.preventDefault();
      if (!slideHold) {
        let slideDuration = trigger.getAttribute('data-duration')
          ? trigger.getAttribute('data-duration')
          : 300;
        let thisTarget = trigger.getAttribute('data-target')
          ? document.querySelector(trigger.getAttribute('data-target'))
          : trigger.closest('.js_slidedown').querySelector('.js_slidedown_content');
        slideToggle(thisTarget, slideDuration);
        if (trigger.classList.contains('m-active')) {
          trigger.classList.remove('m-active');
          if (trigger.closest('.js_slidedown')) {
            trigger.closest('.js_slidedown').classList.remove('m-active');
          }
        } else {
          trigger.classList.add('m-active');
          if (trigger.closest('.js_slidedown')) {
            trigger.closest('.js_slidedown').classList.add('m-active');
          }
        }
      }
      setTimeout(() => {
        scrollHold = false;
      }, 501);

    });
  });
  // ========================

  // STUFF ON SCROLL
  let lastScrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

  function onScroll() {
    // detect scroll
    const scrolledGap = 42;
    const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    scrollTop > scrolledGap
      ? document.body.classList.add('m-scrolled')
      : document.body.classList.remove('m-scrolled');
    // =========

    if (!scrollHold) {
      scrollTop < lastScrollTop
        ? document.body.classList.add('m-scrolled-up')
        : document.body.classList.remove('m-scrolled-up');
    }
    lastScrollTop = Math.max(scrollTop, 0); // For mobile or negative scrolling

  }
  onScroll();
  let throttlescroll;
  window.addEventListener('scroll', function () {
    clearTimeout(throttlescroll)
    throttlescroll = setTimeout(function () {
      onScroll();
    }, 50)
  }, false)
  // ========================

  // ACTIVE TOGGLE
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      let toggleTarget = ''
      if (trigger.getAttribute('data-target')) {
        toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
      } else if (trigger.getAttribute('href')) {
        toggleTarget = document.querySelector(trigger.getAttribute('href'))
      } else {
        toggleTarget = trigger.closest('.js_toggle');
      }
      trigger.classList.toggle('m-active');
      toggleTarget.classList.toggle('m-active');

      if (trigger.classList.contains('js_burger')) {
        const delay = trigger.classList.contains('m-active')
          ? 0 : 320;
        setTimeout(() => {
          // if (trigger.classList.contains('m-active')) {
          //   bodyStopScroll;
          // } else {
          //   bodyRemoveStopScroll();
          // }
          document.body.classList.toggle('m-burgered');

        }, delay);
      }
    });
  });

  // ========================


  document.querySelectorAll('.js_burger_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      const burger = document.querySelector('.js_burger.m-active');
      if (burger) burger.click();
    });
  });


  // FULL POPUP STUFF
  function bodyStopScroll() {
    const scrollWidth = window.innerWidth - document.documentElement.clientWidth;
    const stopScrollStyle = `
    < style id = "scrollStuff" >
      html { overflow: hidden; }
  body, .js_popup_show_margin { padding - right: ${scrollWidth} px; }
        body { width: auto; }
      </style >
    `;
    document.head.insertAdjacentHTML('beforeend', stopScrollStyle);
  }
  function bodyRemoveStopScroll() {
    document.head.querySelector('#scrollStuff').remove();
  }

  document.querySelectorAll('.js_popup_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const popupTarget = trigger.getAttribute('href')
        ? document.querySelector(trigger.getAttribute('href'))
        : document.querySelector(trigger.getAttribute('data-target'));
      bodyStopScroll();
      popupTarget.classList.add('m-active');
    });
  });

  document.querySelectorAll('.js_popup_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const activePopup = document.querySelector('.js_popup.m-active');
      if (activePopup) {
        activePopup.classList.remove('m-active');
        setTimeout(() => {
          bodyRemoveStopScroll();
        }, 300);
      }
    });
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === "Escape") {
      closePopup();
    }
  });

  function closePopup() {
    const activePopup = document.querySelector('.js_popup.m-active');
    if (activePopup) {
      activePopup.classList.remove('m-active');
      setTimeout(() => {
        bodyRemoveStopScroll();
      }, 300);
    }
  }

  // ==========================

});

  // update APK link
  fetch("https://s3.amazonaws.com/android.utils/app_version_no_google.json")
  .then(response => response.json())
  .then(data => {
    if (data && data.download_url) {
      const apkLink = document.getElementById("apk-link");
      if (!apkLink) {
        return;
      }
      apkLink.href = data.download_url;
    }
  });



// =================================================
// =================================================
// =================================================

